export function BrandMark() {
  return (
    <span className="brand-mark" aria-hidden="true">
      <img src="/raptor-logo.png" alt="" width="52" height="52" />
    </span>
  );
}
